import ThumbnailCard from './ThumbnailCard';

export default ThumbnailCard;
